<template>
	<div class="w-100">
		<div class="w-100 pb-5 mb-5 border-b-semi-grey">
			<p class="heading-5 mb-4">Our Partners</p>
			<!-- <p class="body-2-2-1 sub-title text-15 mb-4">+200 brands trust our hospitality.</p> -->
			<div class="">
				<flickity ref="flickity" class="mb-3" :options="partnerImage">
		      <div class="carousel-cell w-25 mr-4" :id="`V${index}`" v-for="(partner,index) in getMerchant.verified_by">
	        	<div class="w-100">
	        		<a :href="partner.direct_url" target="_blank">
  							<img :src="partner.value" class="w-100" style="height:50px;object-fit: contain;">
  						</a>
  						<b-tooltip :target="`V${index}`" placement="bottom" :title="partner.title">
              </b-tooltip>
	        	</div>
		      </div>
		    </flickity>
			</div>
		</div>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'

	export default{
		components:{
			Flickity
		},
		data(){
			return{
				partnerImage: {
          initialIndex: 0,
          autoPlay: 2000,
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          draggable: true,
          wrapAround: true,
          contain: true,
        },
			}
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		methods:{
			
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/PartnerPreview.vue